import { sva } from '@flipster/styled-system/css';
import { grid, hstack } from '@flipster/styled-system/patterns';

export const datePickerRecipe = sva({
  className: 'date-picker',
  slots: [
    'root',
    'header',
    'caption',
    'gridWrapper',
    'monthGrid',
    'weekGrid',
    'dayLabel',
    'day',
    'fakeInput',
    'fakeInputValue',
    'dropdownFooter',
    'dropdownButton',
  ],
  base: {
    root: {
      w: '100%',
      minW: { tablet: 320 },
      px: { tablet: 16 },
    },
    header: {
      ...hstack.raw({
        justify: 'space-between',
        pt: 8,
        gap: 4,
      }),
    },
    caption: {
      ...hstack.raw({
        textStyle: 'Text/L/Monospace/Strong',
        color: 'content.default.level-5',
        py: 16,
        gap: 12,
        _hover: {
          color: 'content.interaction.hover',
        },
        '&[aria-expanded="true"] svg': {
          transform: 'rotate(180deg)',
        },
      }),
    },
    gridWrapper: {
      pos: 'relative',
      my: 16,
    },
    monthGrid: {
      ...grid.raw({ pos: 'absolute', top: 0, left: 0, w: '100%', columns: 3, gridGap: 10 }),
    },
    weekGrid: {
      ...grid.raw({
        columns: 7,
        gridTemplateRows: 'repeat(7, 1fr)',
        rowGap: 10,
        textStyle: 'Text/S/Monospace/Regular',
        textAlign: 'center',
      }),
    },
    dayLabel: {
      color: 'content.default.level-1',
      h: 22,
    },
    day: {
      pos: 'relative',
      h: 22,
      color: 'content.default.level-5',
      '&[data-weekend="true"]:where(:not(:disabled, [data-selected="true"], [data-range="true"], [data-range-preview="true"]))':
        {
          color: 'content.default.level-2',
        },
      '&[data-today="true"]:where(:not(:disabled, [data-selected="true"], [data-range="true"], [data-range-preview="true"]))':
        {
          color: 'content.accent.info',
          _before: {
            content: '""',
            zIndex: -1,
            pos: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            w: 36,
            h: 36,
            rounded: 36,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'content.accent.info',
          },
        },
      _disabled: {
        cursor: 'not-allowed',
      },
      '&:disabled:where(:not([data-selected="true"], [data-range="true"]))': {
        color: 'content.interaction.disabled',
      },
      '&[data-selected="true"], &[data-range="true"]': {
        color: 'content.accent.info',
      },
      '&:hover:where(:not(:disabled))': {
        color: 'content.default.level-5',
        _before: {
          content: '""',
          zIndex: -1,
          pos: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          w: 36,
          h: 36,
          rounded: 36,
          bgColor: 'content.accent.info',
        },
      },
    },
    fakeInput: {
      ...hstack.raw({
        textStyle: 'Text/L/Monospace/Regular',
        color: 'content.default.level-2',
        h: 48,
        pl: 12,
        pr: 4,
        gap: 12,
        bg: { base: 'background.default.level-3', tablet: 'background.default.level-4' },
        rounded: 8,
      }),
    },
    fakeInputValue: {
      textAlign: 'left',
      flex: 1,
      color: 'content.default.level-5',
      '&[data-placeholder="true"]': {
        color: 'content.default.level-2',
      },
    },
    dropdownFooter: {
      ...hstack.raw({
        w: '100%',
        pt: 24,
        px: 16,
        pb: 16,
        gap: 8,
      }),
    },
    dropdownButton: {
      w: '100%',
      flex: 1,
    },
  },
  variants: {
    displayedTimeUnit: {
      week: {},
      month: {
        weekGrid: {
          visibility: 'hidden',
        },
      },
    },
  },
});
